import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { MyFamilyService } from 'src/app/User/Pages/my-family/my-family.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-selectreciepents',
    templateUrl: './selectreciepents.component.html',
    styleUrls: ['./selectreciepents.component.css'],
    standalone: false
})
export class SelectreciepentsComponent implements OnInit {
  myFamilyInfo: any;
  @Input() shareType;
  @Input() form;
  @Output() Share = new EventEmitter();
  @Output() shareToOther = new EventEmitter();
  @Output() Back = new EventEmitter();
  @Output() shareToTpa = new EventEmitter();
  @Input() professionalInfo: any;
  subscriptions = new Subscription();
  ProfessionalInfo: any;

  constructor(
    private familyService: MyFamilyService,
    private userService: UserService
  ) {
  }
  ngOnInit(): void {
    if (this.shareType?.family) {
      if (this.shareType?.name === 'TPA') {
        this.GetProfessionalList(this.professionalInfo);
      } else {
        this.GetMyFamilyInfo();
      }
    }
  }
  blobUrl = environment.blobURL;
  async GetMyFamilyInfo() {
    const myFamilyInfo = (
      await this.familyService.GetMyFamilyInfo().toPromise()
    )?.data?.filter((i) => !i.isDisabled);
    if (myFamilyInfo.length == 1) {
      myFamilyInfo[0].fullName = 'Myself';
      this.myFamilyInfo = myFamilyInfo;
    } else {
      this.myFamilyInfo = myFamilyInfo.filter(
        (i) => i.user?.id != this.userService.userInfo.id
      );
    }
  }
  GetProfessionalList(id: any) {
    this.subscriptions.add(
      this.familyService.GetProfessionalList(id).subscribe((res) => {
        this.ProfessionalInfo = res.data;
      })
    );
  }
  selectedUsers = [];
  addFamilyMember(user: any, checked: boolean) {
    if (checked) {
      this.selectedUsers.push(user);
    } else {
      this.selectedUsers = this.selectedUsers.filter((i) => i.id !== user.id);
    }
  }

  addAll(checked) {
    if (checked) {
      this.selectedUsers = [...this.myFamilyInfo.map((i) => i.user)];
    } else {
      this.selectedUsers = [];
    }
  }
  checked(id) {
    return this.selectedUsers.some((i) => i.id == id);
  }
  share(value: any): void {
    if (value?.family) {
      if (value?.name === 'TPA') {
        this.shareToTpa.emit(this.selectedUsers);
      } else {
        this.Share.emit(this.selectedUsers);
      }
    } else {
      this.shareToOther.emit();
    }
  }
  goBack() {
    this.Back.emit();
  }
}
